import $ from "jquery";
import ApexCharts from "apexcharts";

const apexChart = () => {
    const init = () => {
        $(document).ready(initCharts);
    };

    const getSeries = (chartType, dataset) => {
        let series = dataset.map(({ label, data }) => ({
            name: label,
            data: data.split(","),
        }));

        if (chartType == "donut" || chartType == "pie") {
            series = dataset.map((data) => parseFloat(data.data));
        }

        return series;
    };

    const createChartOptions = (item, series) => {
        return {
            series,
            chart: {
                type: item.chart_type || "pie",
                width: "100%",
                height: 350,
                stacked: false,
                toolbar: { show: true },
            },
            stroke: {
                show: item.chart_type == "bar" ? false : true,
                curve: "straight",
                lineCap: "butt",
                width: 4,
                dashArray: 0,
            },
            dataLabels: { enabled: false },
            labels: item.dataset.map((data) => data.label),
            legend: { show: false },
            colors: ["#012C53", "#8A9EB0", "#D9D9D9"],
            plotOptions: {
                bar: {
                    colors: {
                        ranges: [
                            {
                                from: -Infinity,
                                to: 0,
                                color: "#D84257",
                            },
                            {
                                from: 0,
                                to: Infinity,
                                color: "#012C53",
                            },
                        ],
                    },
                    columnWidth: "80%",
                },
                pie: {
                    donut: {
                        labels: {
                            show: true,
                            total: {
                                show: true,
                                fontSize: "24px",
                                color: "#475467",

                                label: item?.center_title_doughnut_chart,
                                formatter: () =>
                                    item?.center_sub_title_doughnut_chart,
                            },
                        },
                    },
                },
            },
            responsive: [
                {
                    breakpoint: 600,
                    options: {
                        chart: { width: 200 },
                    },
                },
                {
                    breakpoint: 1240,
                    options: {
                        chart: { width: 350 },
                    },
                },
            ],
        };
    };

    const initCharts = () => {
        const el = {
            apexCharts: ".ApexChartsCard",
            apexChartsCardInfo: ".ApexChartsCard__Info",
            apexChartsCardTooltip: ".ApexChartsCard__Tooltip",
        };
        $(el.apexCharts).each(function (index) {
            const item = $(this).data("item");
            const chartElement = `#apexChart_${index}`;

            const series = getSeries(item.chart_type, item.dataset);
            const options = createChartOptions(item, series);

            document.querySelector(chartElement).innerHTML = "";
            const chart = new ApexCharts(
                document.querySelector(chartElement),
                options
            );
            chart.render();

            // Tooltip Hover
            const tooltipElement = `#ApexChartsCard__Tooltip__${index}`;
            const infoIconElement = `#ApexChartsCard__Info__${index}`;

            $(infoIconElement).on("mouseover", function () {
                $(tooltipElement).css({
                    display: "block",
                    opacity: "1",
                    transform: "translateY(0)",
                });
            });

            $(tooltipElement).on("mouseleave", function () {
                $(tooltipElement).css({
                    opacity: "0",
                    transform: "translateY(20px)",
                });
                setTimeout(() => {
                    $(tooltipElement).css("display", "none");
                }, 300);
            });
        });
    };

    init();
};

try {
    apexChart();
} catch (e) {
    console.error("Post initChart: ", e);
}
